var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50001 5L10 2.5M10 2.5L12.5 5M10 2.5V10.8333M5.83354 8.33333C5.05697 8.33333 4.66868 8.33333 4.3624 8.4602C3.95402 8.62936 3.62937 8.95401 3.46021 9.36239C3.33334 9.66867 3.33334 10.0568 3.33334 10.8333V14.8333C3.33334 15.7668 3.33334 16.2331 3.515 16.5897C3.67479 16.9033 3.92957 17.1587 4.24317 17.3185C4.59935 17.5 5.06584 17.5 5.99744 17.5H14.003C14.9346 17.5 15.4004 17.5 15.7566 17.3185C16.0702 17.1587 16.3254 16.9033 16.4852 16.5897C16.6667 16.2335 16.6667 15.7675 16.6667 14.8359V10.8333C16.6667 10.0568 16.6666 9.66867 16.5397 9.36239C16.3706 8.95401 16.0462 8.62936 15.6378 8.4602C15.3315 8.33333 14.9432 8.33333 14.1667 8.33333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublish);
export default __webpack_public_path__ + "static/media/Publish.e512b3a18c4ed0c313957f700e70e529.svg";
export { ForwardRef as ReactComponent };